<template>
  <Toast :position="group" :group="group">
    <template #message="slotProps">
      <div class="toast-content">
        <div
          class="toast-icon-wrapper"
          :class="'toast-icon--' + slotProps.message.severity"
        >
          <i :class="getIcon(slotProps.message.severity)" class="toast-icon" />
        </div>
        <div class="toast-body">
          <div class="toast-summary" v-text="slotProps.message.summary" />
          <div
            class="toast-detail"
            v-if="slotProps.message.detail"
            v-html="slotProps.message.detail"
          />
        </div>
      </div>
    </template>
  </Toast>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const getIcon = (severity?: string) => {
      switch (severity) {
        case "success":
          return "pi pi-check-circle";
        case "info":
          return "pi pi-info-circle";
        case "warn":
          return "pi pi-exclamation-triangle";
        case "error":
          return "pi pi-times-circle";
        default:
          return "pi pi-info-circle";
      }
    };

    return { getIcon };
  },
  props: {
    group: { type: String, default: "top-right" }
  },
  components: {}
});
</script>

<style scoped lang="scss">
.toast-content {
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: flex-start;
  gap: $space-3;
  padding: $space-1 0;
}

.toast-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: $radius-md;
  flex-shrink: 0;

  &.toast-icon--success {
    background: $success-light;
    color: $success;
  }
  &.toast-icon--info {
    background: $info-light;
    color: $info;
  }
  &.toast-icon--warn {
    background: $warning-bg;
    color: #92750c;
  }
  &.toast-icon--error {
    background: $danger-light;
    color: $danger;
  }
}

.toast-icon {
  font-size: 1.25rem;
}

.toast-body {
  flex: 1;
  min-width: 0;
}

.toast-summary {
  font-weight: $font-weight-semibold;
  font-size: $font-size-base;
  color: $text-primary;
  margin-bottom: $space-1;
}

.toast-detail {
  font-size: $font-size-sm;
  color: $text-secondary;
  line-height: $line-height-base;
}
</style>
